var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { on: { click: _vm.onClick } }, [
    _c("div", { staticClass: "atbName" }, [_vm._v(_vm._s(_vm.buttonLabel))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }